import { Grid } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import { Outlet, useLocation } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import {
  darkBlue,
  emerald,
  lightBlue,
  transparentEmerald,
} from "src/design/ColorPalette";
import { LandingHeader } from "src/components/LandingPage/LandingHeader";
import { LandingFooter } from "src/components/LandingPage/LandingFooter";

const theme = createTheme({
  palette: {
    emerald: {
      main: emerald,
      light: transparentEmerald,
    },
    blue: {
      main: darkBlue,
      light: lightBlue,
    },
  },
});

const Homepage = () => {
  const location = useLocation();
  const isRoot = location.pathname === "/";
  const isBooking = location.pathname.includes("booking");

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LandingHeader />
      {isRoot || isBooking ? (
        <Outlet />
      ) : (
        <Grid container spacing={10} sx={{ minHeight: "90vh" }}>
          <Outlet />
        </Grid>
      )}
      <LandingFooter />
    </ThemeProvider>
  );
};

export default Homepage;
